// src/components/Tech.jsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";
import { styles } from "../styles";

const Tech = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="tech" className="scroll-mt-24 pb-0 mb-2">

        {/* 🔥 TÍTULO PRESENTACIÓN */}
        <motion.div variants={textVariant()} className="text-center">
          <h2
            className={`${styles.heroHeadText} uppercase tracking-tight`}
            style={{ lineHeight: 1.25 }}
          >
            {t("tech.presentationTitle", "PRESENTACIÓ LIVINGSOILS")}
          </h2>
          <br/>
        </motion.div>

        {/* 📌 PRESENTACIÓN CANVA */}
        <motion.div variants={fadeIn("up", "spring", 0.1, 0.75)} className="mt-4">
          <div className="relative w-full max-w-6xl mx-auto overflow-hidden rounded-2xl bg-tertiary shadow-2xl">
            <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
              <iframe
                loading="lazy"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                src="https://www.canva.com/design/DAGKcIElKJs/_eMNHa4eV332fIkDYNwWPw/view?embed"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </motion.div>

      </section>
    </>
  );
};

export default SectionWrapper(Tech, "");
